const messages = {
  bonus: {
    title: "Prezentare generală credite bonus",
    description: "Bonusurile în euro sunt acordate companiilor participante pe baza cifrelor de vânzări transmise.",
    lastMonth: "Luna trecută",
    currentMonth: "Luna curentă",
    totalCurrentYear: "Total an curent",
    totalLastYear: "Total an trecut",
  },
  points: {
    title: "Prezentare generală credite puncte",
    period: "Anul calendaristic curent ({year})",
    totalAwarded: "Total puncte acordate",
    redeemed: "Puncte utilizate",
    totalBalance: "Sold total puncte",
    redemptionRate: "Puncte utilizate ca procent din punctele acordate",
    averageAwarded: "Media punctelor acordate per anvelopă cumpărată",
    standardAwarded: "Puncte nete din liniile de vânzare calculate, inclusiv retururile",
    bsPlusInclBooster: "Puncte din liniile de vânzare cu cantitate pozitivă",
    perTire: "Puncte utilizate per anvelopă cumpărată",
  },
  tires: {
    title: "Prezentare generală cantitate anvelope",
    description: "Anvelope cumpărate de clienți",
    prevMonth: "Luna anterioară",
    totalLastYear: "Total anul trecut",
    purchaseIndirect: "Achiziție prin grossist (indirect)",
    purchaseDirect: "Achiziție prin grossist (direct)",
    totalCurrentYear: "Total an curent",
    currentMonth: "Luna curentă",
  },
  participating: {
    title: "Prezentare generală clienți participanți",
    description: "Companiile care se înregistrează în BRIDGESTONE PLUS pot fi asociate prin numărul de client.",
    total: "Total",
    newThisMonth: "Noi luna aceasta",
    newThisYear: "Noi anul acesta",
    createdInCurrentMonth: "Create în luna curentă (de administrator)",
    loginsCurrentYear: "Autentificări în anul curent (după acceptarea termenilor)",
  },
  brand: {
    title: "Marcă",
    description: "Achizițiile tale în detaliu",
    centerTitle: "După\nmarcă",
  },
  rim: {
    title: "Jantă",
    centerTitle: "După dimensiunea\njantei",
  },
  tireGoals: {
    title: "Obiective anvelope",
    subtitle: "Câștigă puncte pentru achizițiile tale de anvelope.",
    centerTitle: "După dimensiunea\nanvelopei",
    tiresRemaining: "Anvelope rămase",
    progressionTarget: "Țintă de progres: ",
    pointsEarnedPurchases: "puncte câștigate\n" + "prin\n" + "achizițiile tale",
    pointsEarnedBoosters: "puncte câștigate\n" + "prin\n" + "boostere",
    purchasesDetail: "Achizițiile tale în detaliu",
    cta: "Află mai multe despre punctele tale",
    pointsTitle: "Punctele tale",
    pointsSubtitle: "Puncte câștigate din achizițiile Bridgestone",
    achievementsTitle: "Realizările tale",
    achievementsSubtitle: "Angajamentul tău anual:",
    achievementsSubtitle2: "anvelope",
  },
  score: {
    title: "Scor",
    total: "Total",
    credits: "Credite în",
    deductions: "Deduceri în",
        unlockedPoints: "Puncte deblocate",
        pendingPoints: "Puncte în așteptare",
  },
  score_extended: {
    title1: "Sold puncte",
    title2: "Bonus în euro",
    balance: "Sold puncte",
    bonus_in_euro: "Bonus în euro",
    date: "Dată",
    added_points: "Puncte adăugate în",
    total_bands: "Total mărci",
    goal: "Obiectiv",
    tyres_previous_year: "Anvelope vândute anul trecut",
    tyres_current_year: "Anvelope vândute anul acesta",
    target_this_year: "Ținta de vânzări pentru acest an",
    bonus_this_year: "Bonus câștigat (€)",
    loyal_minimum: "Nivel minim de loialitate",
    bonus_multiplier: "Rata multiplicatorului bonusului",
  },
  lastImport: {
    label: "Ultimul import al datelor de vânzări:",
    on: "la",
  },
  wholesalerTable: {
    title: "Clienți participanți în detaliu",
    description: "Mai jos găsești companiile care s-au înregistrat în BRIDGESTONE PLUS cu numărul de client al companiei tale. Poți folosi filtrele pentru o sortare diferită sau căutarea pentru a găsi clienți.",
    columns: {
      customer_number: "Nr. client",
      address_company_name: "Companie",
      address_street: "Stradă și număr",
      address_postal_code: "Cod poștal",
      address_city: "Oraș",
      last_registration: "Ultima înregistrare",
      network: "Rețea",
      profile_group: "Grup",
      tires_amount: "Cantitate anvelope",
      point_balance: "Sold puncte",
      bonus: "Bonus",
      details: "Detalii",
    },
    searchPlaceholder: "Caută",
  },
  dealerTable: {
    columns: {
      date: "Dată",
      wholesaler_bs_plus: "Grossist BS+",
      customer_number: "Număr client",
      article: "Articol",
      brand: "Marcă",
      product: "Produs",
      type: "Tip",
      inch: "Inch",
      season: "Sezon",
      amount: "Cantitate",
      points: "Puncte",
      activity: "Activitate",
      total_points: "Total puncte",
    },
    title: "Tabel dealeri",
    description: "Prezentare generală a activității dealerilor",
  },
  business_units: {
    title: "Unități de business",
    centerTitle: "Pe\nunitate",
  },
  season: {
    title: "Sezon",
    centerTitle: "Pe perioada\nanului",
  },
};

export default {
  messages,
};
